import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';
import ZoomInIcon from '../../icons/ZoomInIcon';
import ZoomOutIcon from '../../icons/ZoomOutIcon';
import RotateLeftIcon from '../../icons/RotateLeftIcon';

const propTypes = {
  scale: PropTypes.number.isRequired,
  minScale: PropTypes.number.isRequired,
  maxScale: PropTypes.number.isRequired,
  onZoomInClick: PropTypes.func.isRequired,
  onZoomOutClick: PropTypes.func.isRequired,
  onRotateLeft: PropTypes.func.isRequired,
  onRotateRight: PropTypes.func.isRequired,
  onRotateLeftStart: PropTypes.func.isRequired,
  onRotateRightStart: PropTypes.func.isRequired,
  onRotateStop: PropTypes.func.isRequired,
};

const PanZoomButtons = ({
  scale,
  minScale,
  maxScale,
  onZoomInClick,
  onZoomOutClick,
  onRotateLeft,
  onRotateRight,
  onRotateLeftStart,
  onRotateRightStart,
  onRotateStop,
}) => {
  return (
    <div className="pinch-zoom-pan-buttons">
      <Button
        onClick={onRotateLeft}
        onMouseDown={onRotateLeftStart}
        onMouseUp={onRotateStop}
        onMouseLeave={onRotateStop}
        onTouchStart={onRotateLeftStart}
        onTouchEnd={onRotateStop}
        className="pinch-zoom-pan-button-rotate"
      >
        <RotateLeftIcon />
      </Button>
      <Button
        onClick={onRotateRight}
        onMouseDown={onRotateRightStart}
        onMouseUp={onRotateStop}
        onMouseLeave={onRotateStop}
        onTouchStart={onRotateRightStart}
        onTouchEnd={onRotateStop}
        className="pinch-zoom-pan-button-rotate"
      >
        <RotateLeftIcon style={{ transform: 'scaleX(-1)' }} />
      </Button>

      <Button
        onClick={onZoomOutClick}
        disabled={scale <= minScale}
        className="pinch-zoom-pan-button-zoom"
      >
        <ZoomOutIcon />
      </Button>
      <Button
        onClick={onZoomInClick}
        disabled={scale >= maxScale}
        className="pinch-zoom-pan-button-zoom"
      >
        <ZoomInIcon />
      </Button>
    </div>
  );
};

PanZoomButtons.propTypes = propTypes;

export default PanZoomButtons;
